/**
 * Thin API client for Linked Wheel + Map (SDD-24 / WL-052b).
 *
 * Wraps the backend routes under `/wheel/` (see yuga_wheel/linked_wheels/urls.py).
 * Uses the shared axios instance (services/request.js) so Token auth + interceptors
 * apply. Every route 404s server-side while LINKED_WHEELS_ENABLED is OFF, and the
 * FE never calls these unless the build flag is ON, so a half-flipped state is inert.
 *
 * Callers should key react-query by resource + wheelId (+ params) and invalidate on
 * writes, per the app's react-query conventions.
 */
import axios from "./request";

/** GET outbound links of a wheel (drill-down list). */
export function listWheelLinks(wheelId) {
  return axios.get(`/wheel/${wheelId}/links/`);
}

/** POST a new edge { target_wheel, label?, order? }. */
export function createWheelLink(wheelId, payload) {
  return axios.post(`/wheel/${wheelId}/links/`, payload);
}

/** PATCH reorder / relabel an existing edge. */
export function updateWheelLink(wheelId, linkId, payload) {
  return axios.patch(`/wheel/${wheelId}/links/${linkId}/`, payload);
}

/** DELETE an edge (owner of source OR owner of target). */
export function deleteWheelLink(wheelId, linkId) {
  return axios.delete(`/wheel/${wheelId}/links/${linkId}/`);
}

/** GET who links INTO this wheel (owner only); optional scope=followers. */
export function listInboundLinks(wheelId, scope) {
  const q = scope ? `?scope=${encodeURIComponent(scope)}` : "";
  return axios.get(`/wheel/${wheelId}/inbound-links/${q}`);
}

/** GET the ego-graph for the map (Premium-gated server-side). */
export function getWheelGraph(wheelId, { hops = 2, scope = "all" } = {}) {
  return axios.get(`/wheel/${wheelId}/graph/?hops=${hops}&scope=${encodeURIComponent(scope)}`);
}

/**
 * GET the creator-wide Linked Wheel Map (surface 2): every wheel a creator owns
 * that the viewer may see + the links among them. Premium-gated server-side.
 */
export function getCreatorWheelGraph(userId) {
  return axios.get(`/wheel/creator/${userId}/graph/`);
}
